import type { FC } from "react";
import { Navigate, useParams } from "react-router";

import { ErrorScreen, LoadingScreen } from "../../screens/index.ts";
import { useContextualRedirect } from "./hooks/use-contextual-redirect.ts";

/**
 * This page is responsible for redirecting the user to the appropriate page
 * based on the current game state and the user's picks.
 *
 * 1. If the game is upcoming or finished, redirect to the splash page.
 * 2. If the user has not made all their picks, redirect them to pick players.
 * 3. If the user has made all their picks, redirect them to play the game.
 */
export const GameLaunchPage: FC = () => {
  const { gameId = "" } = useParams<{ gameId: string }>();

  const { isPending, isError, error, to } = useContextualRedirect();

  if (isPending) return <LoadingScreen />;
  if (isError) return <ErrorScreen error={error} />;

  switch (to) {
    case "SPLASH_PAGE":
      return <Navigate to="/games" replace />;
    case "PICK_PLAYERS_PAGE":
      return <Navigate to={`/games/${gameId}/pick-your-players`} replace />;
    case "PLAY_GAME_PAGE":
      return <Navigate to={`/games/${gameId}/play`} replace />;
  }
};
